import { Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { VTableComponent } from "@app/directives/_layout/v-table/_components/v-table.component";
import { DateService } from "@app/services/date.service";
import "./recently-selected.component.scss";

export interface IRecentlySelectedEntity {
    id: number | string;
    label: string;

    date: Date;
    data?: any;
}

@Component({
    selector: "recently-selected",
    template: require("./recently-selected.component.html")
})
export class RecentlySelectedComponent implements OnChanges {

    @Input() idProp = "Id";
    @Input() labelProp = "Name";
    @Input() icon: string;
    @Input() storageKey: string;

    @Input() table: VTableComponent;
    @Input() maxItems = 10;

    @Output() itemClick = new EventEmitter();

    // ---

    recentList: IRecentlySelectedEntity[] = [];

    @HostBinding("class.empty") isEmpty = true;

    constructor(private readonly dateService: DateService) {
    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes["storageKey"] && changes["table"].isFirstChange()) {
            this.loadRecentList();
        }
        else {
            console.error("storageKey required");
        }

        if (changes["table"] && changes["table"].isFirstChange()) {
            this.table.rowClick.subscribe(row => {
                // Artificially slow this down to occur after any animation has happened
                // Makes for a more pleasing experience
                setTimeout(() => { this.addRecentlySelectedItem(row.data); }, 500);
            });
        }
    }

    recentClicked(item: IRecentlySelectedEntity) {
        setTimeout(() => {
            this.updateDateTimeOnItem(item);
        }, 500);

        this.itemClick.emit(item);
    }

    // ---

    private addRecentlySelectedItem(item: any) {
        const itemId = item[this.idProp] || item["Id"] || item["id"];
        const label = this.getNestedProperty(item, this.labelProp) || item["Name"] || item["Description"] || "[labelProp] missing";

        this.recentList = this.recentList || [];

        var existingItem = this.recentList.find(r => r.id == itemId)
        if (existingItem) {
            this.updateDateTimeOnItem(existingItem);
            return;
        }

        this.recentList.push({
            id: itemId,
            label: label,
            date: new Date(),
            data: item
        });

        this.removeOldItems();
        this.saveRecentList();
        this.updateEmptyClass();
    }

    private updateDateTimeOnItem(item: IRecentlySelectedEntity) {
        item.date = new Date();
        this.sortList();
        this.saveRecentList();
    }

    private getNestedProperty(item: any, propString: string): any {
        const propValue = propString
            .replace(/\[([^\[\]]*)\]/g, '.$1.')
            .split('.')
            .filter(t => t !== '')
            .reduce((prev, cur) => prev && prev[cur], item);

        return propValue;
    }

    private removeOldItems() {
        this.sortList();
        this.recentList.length = Math.min(this.recentList.length, 5);
    }

    private sortList() {
        this.recentList.sort((a, b) => this.dateService.sort(a.date, b.date));
    }

    private loadRecentList() {
        var jsonString = localStorage.getItem(this.storageKey);
        this.recentList = JSON.parse(jsonString) as IRecentlySelectedEntity[];
        this.updateEmptyClass();
    }

    private saveRecentList() {
        // Clear data before saving
        this.recentList.forEach(c => c.data = null);

        localStorage.setItem(this.storageKey, JSON.stringify(this.recentList));
    }

    private updateEmptyClass(): void {
        this.isEmpty = this.recentList?.length == 0;
    }
}
